import React from "react";
import { Modal, Button, Typography, Divider } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import { useAIAssessmentContext } from "../../../../Context/AIAssessmentContext/AIAssessmentContext";
import useAiAssessmentStart from "../../hooks/useAiAssessmentStart";
import "./modals.scss";

const SuspiciousKeyPressModal: React.FC = () => {
  const {
    showSuspiciousKeyPressModal,
    setShowSuspiciousKeyPressModal,
    pressedSuspiciousKey,
    setPressedSuspiciousKey,
    fullscreenElementRef,
    isFullscreen,
    clearExitFullScreenState,
  } = useAIAssessmentContext();

  const { toggleToFullscreenMode } = useAiAssessmentStart();

  const handleClose = () => {
    setShowSuspiciousKeyPressModal(false);
    setPressedSuspiciousKey(null);

    if (!isFullscreen) {
      toggleToFullscreenMode();
    }

    clearExitFullScreenState();
  };

  return (
    <Modal
      closeIcon={false}
      destroyOnClose={true}
      centered
      keyboard={false}
      open={showSuspiciousKeyPressModal}
      onCancel={handleClose}
      maskClosable={false}
      footer={null}
      getContainer={
        isFullscreen ? () => fullscreenElementRef.current! : undefined
      }
    >
      <div className="modal-content">
        <div className="modal-content-header">
          <Typography.Title level={5} style={{ margin: 0 }}>
            Suspicious Key Press Detected !!
          </Typography.Title>
        </div>
        <Divider style={{ margin: 0 }} />
        <div className="violation-modal-content-icon">
          <WarningOutlined />
        </div>

        <Typography.Text>
          Suspicious key press detected during the AI Assessment Rounds.
        </Typography.Text>

        {pressedSuspiciousKey && (
          <Typography.Text strong>
            Pressed key: {pressedSuspiciousKey}
          </Typography.Text>
        )}
      </div>
      <div className="ai-assessment-modal-footer">
        <Button type="default" onClick={handleClose}>
          Close
        </Button>
      </div>
    </Modal>
  );
};

export default SuspiciousKeyPressModal;
